export const UTIL_CONSTS = {
    START_LOADING: "START_LOADING",
    END_LOADING: "END_LOADING",
    TOGGLE_LINEAR_LOADING: "TOGGLE_LINEAR_LOADING",

    SET_META_DATA: "SET_META_DATA",
    CLEAR_META_DATA: "CLEAR_META_DATA",
};
